import { render } from "./socialMedia.vue?vue&type=template&id=35b51872&scoped=true"
const script = {}

import "./socialMedia.vue?vue&type=style&index=0&id=35b51872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b51872"]])

export default __exports__